import React from 'react';

function PageNotFound() {
  return (
    <>
      <h1>Oops! Nothing here.</h1>
    </>
  );
}

export default PageNotFound;
